var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    viewBox: "0 0 14 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 0a7.533 7.533 0 00-7 4.5A7.533 7.533 0 007 9a7.533 7.533 0 007-4.5A7.533 7.533 0 007 0zm0 7.5a3.1 3.1 0 01-3.181-3A3.1 3.1 0 017 1.5a3.1 3.1 0 013.181 3A3.1 3.1 0 017 7.501zm0-4.8a1.863 1.863 0 00-1.909 1.8A1.863 1.863 0 007 6.3a1.863 1.863 0 001.909-1.8A1.863 1.863 0 007 2.7z"
  })));
}

export default SvgIconEye;